import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<li class=\"cNA--list__item cNA--list__item--footer notifications-toggle\">\n  <Shared::Ui::Button\n    @additional=\"block\"\n    @class=\"cNA--nav__link\"\n    @variant=\"unstyled\"\n    data-test-id=\"notification-center\"\n  >\n    {{svg-jar \"notification\" class=\"o--icon--md cNA--list__icon\"}}\n    <span class=\"cNA--list__label\">{{t \"shared_words.notifications\"}}</span>\n    {{#if this.unreadCount}}\n      <span class={{concat-classes \"cNO--badgeNotification o--btn--sm\" this.badgeClass}}>\n        {{this.unreadCount}}\n      </span>\n    {{/if}}\n  </Shared::Ui::Button>\n</li>\n\n<Shared::Ui::EmberDrop\n  @constrainToScrollParent={{true}}\n  @constrainToWindow={{true}}\n  @contentSelector=\".cNO--panel\"\n  @onOpen={{this.onOpen}}\n  @openOn=\"click\"\n  @position=\"right center\"\n  @target=\".notifications-toggle\"\n  as |emberDrop|\n>\n  <div class=\"cNO--panel\">\n    <div class=\"cNO--panelHeader\">\n      <div class=\"cNO--panelHeader__section\">\n        <span class=\"u--text--light u--text--bold\">{{t \"shared_words.notifications\"}}</span>\n        {{#if this.showMarkAllAsRead}}\n          <Shared::Ui::Button @onClick={{this.markAllAsRead}} @variant=\"unstyled\" class=\"cNO--panelHeader__btn\">\n            {{t \"notifications.header.mark_all_read\"}}\n            {{svg-jar \"verified\" class=\"o--icon o--icon--hl o--icon--sm\"}}\n          </Shared::Ui::Button>\n        {{/if}}\n      </div>\n      <nav class=\"o--nav--underline cNO--panelNav\">\n        {{#each this.notificationTabs as |notificationTab|}}\n          <div class=\"o--nav__item cNO--panelNav__item\">\n            <Shared::Ui::Button\n              @class={{if (eq this.activeTab notificationTab.key) \"active\"}}\n              @onClick={{set this \"activeTab\" notificationTab.key}}\n              @size=\"small\"\n              @variant=\"unstyled\"\n              class=\"o--nav__link cNO--panelNav__link\"\n            >\n              {{notificationTab.name}}\n              {{#if notificationTab.showUnreadCount}}\n                <span class={{concat-classes \"cNO--badgeNotification o--btn--sm\" this.badgeClass}}>\n                  {{this.unreadCount}}\n                </span>\n              {{/if}}\n            </Shared::Ui::Button>\n          </div>\n        {{/each}}\n      </nav>\n    </div>\n    <ul\n      class={{concat-classes\n        \"cNO--panelBody\"\n        (unless\n          this.notificationsItems.length \"u--flex u--flex__col u--flex__justify--center u--flex__alignContent--center\"\n        )\n      }}\n    >\n      {{#each this.notificationsItems as |notificationItem|}}\n        {{component\n          (this.getNotificationComponent notificationItem)\n          close=emberDrop.closeAction\n          notification=notificationItem\n        }}\n      {{else}}\n        <div class=\"img--empty__conversations\"></div>\n      {{/each}}\n      <div class=\"u--flex u--flex__justify--center u--m__sm\">\n        {{#if this.canLoadMore}}\n          <Shared::Ui::Button\n            @isDisabled={{this.loadMore.isRunning}}\n            @onClick={{perform this.loadMore}}\n            @size=\"large\"\n            @text={{this.loadMoreButtonText}}\n            @variant=\"outline\"\n          />\n        {{else}}\n          <span class=\"u--text--light u--text--bold\">{{t \"notifications.all_loaded\"}}</span>\n        {{/if}}\n      </div>\n    </ul>\n  </div>\n</Shared::Ui::EmberDrop>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<li class=\"cNA--list__item cNA--list__item--footer notifications-toggle\">\n  <Shared::Ui::Button\n    @additional=\"block\"\n    @class=\"cNA--nav__link\"\n    @variant=\"unstyled\"\n    data-test-id=\"notification-center\"\n  >\n    {{svg-jar \"notification\" class=\"o--icon--md cNA--list__icon\"}}\n    <span class=\"cNA--list__label\">{{t \"shared_words.notifications\"}}</span>\n    {{#if this.unreadCount}}\n      <span class={{concat-classes \"cNO--badgeNotification o--btn--sm\" this.badgeClass}}>\n        {{this.unreadCount}}\n      </span>\n    {{/if}}\n  </Shared::Ui::Button>\n</li>\n\n<Shared::Ui::EmberDrop\n  @constrainToScrollParent={{true}}\n  @constrainToWindow={{true}}\n  @contentSelector=\".cNO--panel\"\n  @onOpen={{this.onOpen}}\n  @openOn=\"click\"\n  @position=\"right center\"\n  @target=\".notifications-toggle\"\n  as |emberDrop|\n>\n  <div class=\"cNO--panel\">\n    <div class=\"cNO--panelHeader\">\n      <div class=\"cNO--panelHeader__section\">\n        <span class=\"u--text--light u--text--bold\">{{t \"shared_words.notifications\"}}</span>\n        {{#if this.showMarkAllAsRead}}\n          <Shared::Ui::Button @onClick={{this.markAllAsRead}} @variant=\"unstyled\" class=\"cNO--panelHeader__btn\">\n            {{t \"notifications.header.mark_all_read\"}}\n            {{svg-jar \"verified\" class=\"o--icon o--icon--hl o--icon--sm\"}}\n          </Shared::Ui::Button>\n        {{/if}}\n      </div>\n      <nav class=\"o--nav--underline cNO--panelNav\">\n        {{#each this.notificationTabs as |notificationTab|}}\n          <div class=\"o--nav__item cNO--panelNav__item\">\n            <Shared::Ui::Button\n              @class={{if (eq this.activeTab notificationTab.key) \"active\"}}\n              @onClick={{set this \"activeTab\" notificationTab.key}}\n              @size=\"small\"\n              @variant=\"unstyled\"\n              class=\"o--nav__link cNO--panelNav__link\"\n            >\n              {{notificationTab.name}}\n              {{#if notificationTab.showUnreadCount}}\n                <span class={{concat-classes \"cNO--badgeNotification o--btn--sm\" this.badgeClass}}>\n                  {{this.unreadCount}}\n                </span>\n              {{/if}}\n            </Shared::Ui::Button>\n          </div>\n        {{/each}}\n      </nav>\n    </div>\n    <ul\n      class={{concat-classes\n        \"cNO--panelBody\"\n        (unless\n          this.notificationsItems.length \"u--flex u--flex__col u--flex__justify--center u--flex__alignContent--center\"\n        )\n      }}\n    >\n      {{#each this.notificationsItems as |notificationItem|}}\n        {{component\n          (this.getNotificationComponent notificationItem)\n          close=emberDrop.closeAction\n          notification=notificationItem\n        }}\n      {{else}}\n        <div class=\"img--empty__conversations\"></div>\n      {{/each}}\n      <div class=\"u--flex u--flex__justify--center u--m__sm\">\n        {{#if this.canLoadMore}}\n          <Shared::Ui::Button\n            @isDisabled={{this.loadMore.isRunning}}\n            @onClick={{perform this.loadMore}}\n            @size=\"large\"\n            @text={{this.loadMoreButtonText}}\n            @variant=\"outline\"\n          />\n        {{else}}\n          <span class=\"u--text--light u--text--bold\">{{t \"notifications.all_loaded\"}}</span>\n        {{/if}}\n      </div>\n    </ul>\n  </div>\n</Shared::Ui::EmberDrop>","moduleName":"later/components/nav/notification-center.hbs","parseOptions":{"srcName":"later/components/nav/notification-center.hbs"}});
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';

import { SegmentEventTypes } from 'later/utils/constants/segment-events';

import type { FeedItem } from '@knocklabs/client';
import type IntlService from 'ember-intl/services/intl';
import type AppHeaderService from 'later/services/app-header';
import type NotificationsService from 'later/services/notifications';
import type SegmentService from 'later/services/segment';
import type { EmptyObject } from 'shared/types';

enum NotificationTabKey {
  All = 'all',
  Unread = 'unread',
  Read = 'read'
}

enum NotificationType {
  ExternalPostCommented = 'later-social-post-commented-external',
  PostApproved = 'later-social-post-approved',
  PostCommented = 'later-social-post-commented',
  PostSubmitted = 'later-social-post-submitted',
  PostDeleted = 'later-social-post-deleted',
  Generic = 'later-social-generic'
}

interface AppFooterListComponentSignature {
  Element: HTMLDivElement;
  Args: EmptyObject;
  Blocks: {
    default: [];
  };
}

interface NotificationTab {
  key: NotificationTabKey;
  name: string;
  showUnreadCount?: boolean;
}

export default class AppFooterListComponent extends Component<AppFooterListComponentSignature> {
  @service declare appHeader: AppHeaderService;
  @service declare intl: IntlService;
  @service declare notifications: NotificationsService;
  @service declare segment: SegmentService;

  @tracked activeTab = NotificationTabKey.All;

  MAX_NOTIFICATION_SM_CLASS = 99;

  get notificationTabs(): NotificationTab[] {
    return [
      {
        key: NotificationTabKey.All,
        name: this.intl.t('notifications.header.tabs.all')
      },
      {
        key: NotificationTabKey.Unread,
        name: this.intl.t('notifications.header.tabs.unread'),
        showUnreadCount: Boolean(this.notifications.feedItems.filter((notification) => !notification.read_at).length)
      },
      {
        key: NotificationTabKey.Read,
        name: this.intl.t('notifications.header.tabs.read')
      }
    ];
  }

  get unreadCount(): number {
    return this.notifications.unreadFeedItems.length;
  }

  get badgeClass(): string {
    if (this.unreadCount <= this.MAX_NOTIFICATION_SM_CLASS) {
      return 'u--text--sm';
    }

    return 'u--text--xs';
  }

  get canLoadMore(): boolean {
    return Boolean(this.notifications.feed?.pageInfo.after);
  }

  get showMarkAllAsRead(): boolean {
    return Boolean(this.notifications.feedItems.length);
  }

  get notificationsItems(): FeedItem[] {
    let notificationsItems = this.notifications.feedItems.filter((feedItem) => !feedItem.archived_at);

    if (this.activeTab === NotificationTabKey.Unread) {
      notificationsItems = this.notifications.feedItems.filter((notification) => !notification.read_at);
    }

    if (this.activeTab === NotificationTabKey.Read) {
      notificationsItems = this.notifications.feedItems.filter((notification) => notification.read_at);
    }

    return notificationsItems;
  }

  get loadMoreButtonText(): string {
    if (this.canLoadMore && !this.notificationsItems.length && this.activeTab !== NotificationTabKey.All) {
      return this.intl.t('shared_words.refresh');
    }
    return this.loadMore.isRunning ? this.intl.t('shared_words.loading') : this.intl.t('shared_phrases.load_more');
  }

  @action
  markAllAsRead(): void {
    this.notifications.markAllAsRead();
  }

  @action
  onOpen(): void {
    this.segment.track(SegmentEventTypes.OpenedNotificationPanel, {
      notification_number: this.notificationsItems.length
    });
    this.appHeader.hideFlyout();
  }

  getNotificationComponent(feedItem: FeedItem): string {
    if (feedItem.source.key === NotificationType.PostApproved) {
      return 'nav/notification/post-approved';
    }

    if (feedItem.source.key === NotificationType.PostCommented) {
      return 'nav/notification/post-commented';
    }

    if (feedItem.source.key === NotificationType.ExternalPostCommented) {
      return 'nav/notification/external-post-commented';
    }

    if (feedItem.source.key === NotificationType.PostSubmitted) {
      return 'nav/notification/post-submitted';
    }

    if (feedItem.source.key === NotificationType.PostDeleted) {
      return 'nav/notification/post-deleted';
    }

    return 'nav/notification/generic';
  }

  loadMore = task(async () => {
    await this.notifications.loadMore.perform();
  });
}
